<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="item ? item.name : ''"
        centered
        @hidden="cancelar"
        id="detail-group"
    >
        <div class="row px-0" v-if="item">
            <h5 class="col-12">
                Criado: {{ $options.filters.formatDateHora(item.created_at) }}
            </h5>
            <h5 class="col-12">{{ item.members.length }} Participantes</h5>
            <div class="col-12" v-for="user in item.members" :key="user.id">
                <b>{{ user.nome }}</b>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["item", "contacts"],
    data() {
        return {
            loading: false,
            title_group: "",
            users: [],
            users_selected: [],
        };
    },
    mounted() {},
    methods: {
        submit() {
            axios
                .post(`api/dashboard/chat/markread`, {
                    name: this.title_group,
                    users: this.users_selected,
                })
                .finally(() => {
                    this.$emit("create");
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("detail-group");
        },
    },
};
</script>
